import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import {
  Box,
  Container,
  Paper,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { MainLayout } from '../components/Layout/MainLayout';
import { ChatContainer } from '../components/Chat/ChatContainer';
import { useBreakpoints } from '../hooks/useBreakpoints';

/**
 * チャットページメインコンポーネント
 * シンプルな1カラムレイアウトでメインチャットエリアのみ表示
 * チャット履歴は左サイドバーに統合済み
 */
export const ChatPage: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const { sessionId } = useParams<{ sessionId: string }>();
  const [searchParams] = useSearchParams();
  const [selectedSessionId, setSelectedSessionId] = useState<number | null>(null);
  const [currentView, setCurrentView] = useState<'welcome' | 'chat'>('welcome');

  // URLパラメータからsessionIdを取得し、stateに設定
  useEffect(() => {
    const resetParam = searchParams.get('reset');
    
    if (resetParam === 'true') {
      // リセットパラメータがある場合は、セッションIDをクリア
      setSelectedSessionId(null);
      setCurrentView('welcome');
    } else if (sessionId) {
      const numericSessionId = parseInt(sessionId, 10);
      if (!isNaN(numericSessionId)) {
        setSelectedSessionId(numericSessionId);
      }
    } else {
      // セッションIDもリセットパラメータもない場合
      setSelectedSessionId(null);
    }
  }, [sessionId, searchParams]);

  const handleSessionChange = (sessionId: number | null) => {
    setSelectedSessionId(sessionId);
  };

  const handleViewChange = (view: 'welcome' | 'chat') => {
    setCurrentView(view);
  };

    return (
    <MainLayout 
      title="ガクフドキャリア"
      showHeader={isMobile}
      showFooter={false}
      maxWidth={false}
      currentView={currentView}
    >
      <Box 
        sx={{ 
          height: 'calc(100vh - 0px)', // フッターとヘッダーがないので100vh
          margin: -3, // MainLayoutのパディングを打ち消し
          padding: 0,
        }}
      >
        <ChatContainer 
          selectedSessionId={selectedSessionId}
          onSessionChange={handleSessionChange}
          onViewChange={handleViewChange}
        />
      </Box>
    </MainLayout>
  );
};